export default __webpack_public_path__ + "static/media/marker.473fd97b.svg";